export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$-/!%*?&])([A-Za-z\d$@$-/!%*?&]|[^ ]){8,15}$/;